/* eslint-disable no-template-curly-in-string */
/* eslint sort-keys: 'error' */
export default {
  'govhub.ebilling': 'Facturación electrónica',
  'govhub.forms': 'Formularios',
  'govhub.login': 'Iniciar sesión',
  'govhub.logout': 'Cerrar sesión',
  'govhub.settings': 'Configuración',
}
